export default __webpack_public_path__ + "static/media/step-2.1531efd9.svg";